// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__odQPf","logo":"sidebar_logo__WzZAG","menu":"sidebar_menu__gHzeF","title":"sidebar_title__W3q6o","items":"sidebar_items__yqIe6"};